// src/components/charts/UserChart.js
import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const UserChart = ({ data }) => {
  const COLORS = ['var(--color-primario)', 'var(--color-secundario)', 'var(--color-acento)', '#ff6b6b', '#51cf66', '#feca57', '#a463f5', '#00d2d3', '#ff9f43', '#ff5e7d'];
  
  if (!data || data.length === 0) {
    return (
      <div className="chart-container empty-chart">
        <h3>🏆 Top Creadores por tokens</h3>
        <p className="empty-message">No hay datos suficientes para mostrar el gráfico</p>
      </div>
    );
  }

  // Transformar datos para el gráfico (solo mostrar los que tienen tokens > 0)
  const chartData = data
    .filter(user => user.tokens > 0)
    .map((user, index) => ({
      name: user.username,
      value: user.tokens || 0,
      historias: user.historias,
      imagenes: user.imagenes
    }));

  if (chartData.length === 0) {
    return (
      <div className="chart-container empty-chart">
        <h3>🏆 Top Creadores por tokens</h3>
        <p className="empty-message">Aún no hay consumo de tokens para mostrar</p>
      </div>
    );
  }

  return (
    <div className="chart-container">
      <h3>🏆 Top Creadores por tokens</h3>
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
            outerRadius={120}
            fill="#8884d8"
            dataKey="value"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip 
            contentStyle={{ 
              background: 'var(--color-fondo)', 
              border: '1px solid var(--color-primario)',
              borderRadius: '10px'
            }}
            formatter={(value, name, props) => [
              `${value.toLocaleString()} tokens`,
              props.payload.name
            ]}
          />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UserChart;